import React from 'react';
import './PaymentSuccess.css';
import { Link } from 'react-router-dom';
const PaymentSuccess = () => {
    return (
        <>
            <div className='payment-sucess-container'>
                <div className='payment-sucess-main'>
                    <div className='payment-sucess-div'>
                        <p className='payment-sucess_text-h'>
                            Congratulations!
                        </p>
                        <div className='payment-sucess-inner-small_div'>
                            Your payment has been processed successfully.
                        </div>
                        {/* <div className="payment-sucess-inner-small_div payment-sucess-mt-40">Your Starter Plan will be active shortly. You will receive a confirmation <br />
                            email with all the details.</div> */}
                        <div className='payment-sucess-inner-small_div payment-sucess-mt-80'>
                            Thank you for choosing QuickAction! if you have any
                            questions,feel free <br />
                            to contact our support team at{' '}
                            <span>support@quickaction.ai</span>
                        </div>
                        <Link to='/' className='payment-sucess-btn'>
                            Back To Home
                        </Link>
                    </div>
                </div>
            </div>
        </>
    );
};
export default PaymentSuccess;
